(function () {
  'use strict';

  /* slide helpers */

  function slideUp(target, duration) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight; // reflow
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    setTimeout(function () {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  function slideDown(target, duration) {
    target.style.removeProperty('display');
    var display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight; // reflow
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    setTimeout(function () {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  /* modal */

  var modal = document.getElementById('local-product-modal');
  var lastTrigger = null;

  if (modal) {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-local-product-modal-trigger]');
      if (trigger) {
        lastTrigger = trigger;
        modal.showModal();
      }
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-local-product-modal-close]')) {
        modal.close();
      }
      if (e.target === modal) {
        modal.close();
      }
    });

    modal.addEventListener('close', function () {
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    });
  }

  /* accordion */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-local-accordion-trigger]');
    if (!trigger) return;

    var accordion = trigger.closest('[data-local-accordion]');
    if (!accordion) return;

    var body = accordion.querySelector('[data-local-accordion-body]');
    var isOpen = accordion.classList.contains('is-open');

    if (isOpen) {
      accordion.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      slideUp(body, 200);
    } else {
      accordion.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      slideDown(body, 200);
    }
  });

}());
